// In the top bar the panels open under it, at the right, so they never cover the button that opened them.
export const UNDER_TOP_BAR = {top: 76, bottom: 'auto', right: 24, maxHeight: 'calc(100vh - 96px)'};

export const panelPlacement = (inTopBar, dragStyle) => (inTopBar ? UNDER_TOP_BAR : dragStyle);
